<template>
	<svg width="16px" height="4px" viewBox="0 0 16 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
		<title>Icon_minus</title>
		<desc>Created with Sketch.</desc>
		<g id="Visual-Design" stroke="none" stroke-width="1" fill="none"
			fill-rule="evenodd">
			<g id="S30-Open-Large-Menu" transform="translate(-180.000000, -240.000000)"
				fill="#231F20" fill-rule="nonzero">
				<g id="Group-7-Copy-6" transform="translate(159.000000, 213.000000)">
					<g id="Group-6">
						<g id="Group-9" transform="translate(7.000000, 7.000000)">
							<rect id="Icon_minus"
									transform="translate(22.000000, 22.000000) rotate(-90.000000) translate(-22.000000, -22.000000) "
									x="20" y="14" width="4" height="16"></rect>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: "SvgIconMinus"
};
</script>